var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeartbeatIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 23C16.3842 22.9986 16.2719 22.96 16.1797 22.8899L9.87346 16.886C8.80671 15.8471 8.31681 14.3517 8.56216 12.8833C8.86853 11.1632 10.1035 9.75468 11.7691 9.22555C13.4348 8.69642 15.2566 9.13392 16.5 10.3617C17.7393 9.13466 19.5559 8.69376 21.22 9.21612C22.8842 9.73848 24.1226 11.1384 24.4378 12.8533C24.6832 14.3217 24.1933 15.8171 23.1265 16.856L16.8403 22.8599C16.7488 22.9481 16.6271 22.9982 16.5 23ZM13.1667 9.93139C12.6553 9.92747 12.1494 10.0368 11.6852 10.2516C10.5467 10.7479 9.72647 11.7739 9.49308 12.9934C9.27379 14.1698 9.64819 15.3788 10.4941 16.2255L16.5 21.8893L22.5059 16.2255C23.3488 15.3769 23.7227 14.1696 23.5069 12.9934C23.2303 11.5545 22.1433 10.4069 20.721 10.0526C19.2988 9.69819 17.8002 10.2015 16.8804 11.3423C16.7819 11.4477 16.6442 11.5075 16.5 11.5075C16.3558 11.5075 16.2181 11.4477 16.1196 11.3423C15.3984 10.4511 14.3134 9.93268 13.1667 9.93139Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeartbeatIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/HeartbeatIcon.3698efbfd643a98c692b86a69e0d8a64.svg";